import { useContext, useEffect, useState } from "react";
import ThumbnailContext from "./ThumbnailContext";
import { THUMBNAIL_BATCH_SIZE, THUMBNAIL_FETCH_SIZE } from "../../constants/Constants";
import studyviewerContext from "./StudyviewerContext";
import { prefetchData } from "../../pages/StudyViewer/helpers/CornerstoneThumbnailService";
import { isMobile } from "react-device-detect";

const ThumbnailState = (props) => {

  const {nonFrontalImages, stackListSortedByImages, studyData, priorsStudyData, isPriorsStudy, prefetchCount, hpNotFound} = useContext(studyviewerContext);

  const [impressionHoveredStudyId, setImpressionHoveredStudyId] = useState(0);
  const [seriesHovered, setSeriesHovered] = useState(false);
  const [impressionHovered, setImpressionHovered] = useState(false);
  const [activeStudyId, setActiveStudyId] = useState("");
  const [activeModality, setActiveModality] = useState("");
  const [activeThumbnailIndex, setActiveThumbnailIndex] = useState(0);
  const [activeMPRThumbnailIndex, setActiveMPRThumbnailIndex] = useState(0);
  const [activeId, setActiveId] = useState("");
  const [activeColor, setActiveColor] = useState("");
  const [thumbnailElements, setThumbnailElements] = useState([]);
  const [lateralThumbnailIndex, setLateralThumbnailIndex] = useState(null);
  const [stackScrollActiveThumbnailIndex, setStackScrollActiveThumbnailIndex] =
    useState(-1);
  let tempThumbnailElements = [];
  const [thumbnailViewports, setThumbnailViewports] = useState([
    {
      element: "sampleElement",
      thumbnailIndex: "1",
    },
  ]);

  const [activeThumbnailData, setActiveThumbnailData] = useState({});
  const [thumbnailLoadingComplete, setThumbnailLoadingComplete] =
    useState(false);
  const [loadUptoIndex, setLoadUptoIndex] = useState(THUMBNAIL_BATCH_SIZE);

  const initialMap = new Map();
  for (let i = 0; i < 5; i++) {
    initialMap.set(i, false);
  }
  const [thumbnailLoadMap, setThumbnailLoadMap] = useState(initialMap);

  // const [isPrefetchStarted, setIsPrefetchStarted] = useState(false);

  const addThumbnailElements = (element) => {
    tempThumbnailElements.push(element);
    setThumbnailElements(tempThumbnailElements);
  };

  useEffect(() => {
    const fetchData = async () => {
      await startPrefetching(); 
    };
    
    if (stackListSortedByImages.length > 0) {
      fetchData(); 
    }
  }, [stackListSortedByImages]); 

  useEffect(() => {
    if(hpNotFound){
      setStackScrollActiveThumbnailIndex(0);
    }
  }, [hpNotFound]);
  
  const startPrefetching = async () => {
    for (const item of stackListSortedByImages) {
      await new Promise((resolve) => setTimeout(resolve, 1200)); 
      if ((studyData.stack === undefined || studyData.stacks[item.index].modality !== 'SR')) {
        if ((!isMobile && (item.length <= prefetchCount || prefetchCount === -1)) || (isMobile && item.length <= THUMBNAIL_FETCH_SIZE)){
          await prefetchData(item.index, null); 
        }
      }
    }
  };
  


  const changeActiveThumbnailData = (study, series, modality) => {
    // console.log(
    //   "in changeActiveThumbnailData " + study + " " + series + " " + modality
    // );
    setActiveThumbnailData({ series, study, modality });
    // console.log(activeThumbnailData);
  };

  const changeActiveThumbnailIndex = (index) => {
    // console.log(index);
    setActiveThumbnailIndex(index != undefined ? Number(index) : -1);
  };

  const addthumbnailViewports = (element, thumbnailIndex) => {
    setThumbnailViewports(
      [...thumbnailViewports].push({
        element,
        thumbnailIndex,
      })
    );
  };

  const checkIfParentStudyThumbnailIsLoaded = (
    parentStudyId,
    viewportSeriesData,
    currentIndex
  ) => {
    let result = false;
    viewportSeriesData.map((data) => {
      if (
        data.study != "" &&
        data.study == parentStudyId &&
        data.thumbnailIndex == currentIndex
      ) {
        result = true;
      }
    });
    return result;
  };

  const checkForThumbnailReinference = (viewportSeriesData, forceReinferenceImageIds, index, thumbnailStack) => {

    let result = false;
    viewportSeriesData.map((data) => {
      if (
        data.study != "" && data.thumbnailIndex == index && forceReinferenceImageIds.length > 0
        && forceReinferenceImageIds.some(item => data.stack?.imageIds.includes(item))
      ) {
        result = true;
      }
    });

    if(nonFrontalImages.some(item => thumbnailStack?.imageIds.includes(item.imageUrl) && item.isSentForForceReinference)) {
      result = true;
    }

    return result;
  }

  return (
    <ThumbnailContext.Provider
      value={{
        activeThumbnailIndex,
        changeActiveThumbnailIndex,
        addthumbnailViewports,
        thumbnailViewports,
        setThumbnailViewports,
        changeActiveThumbnailData,
        activeThumbnailData,
        setActiveThumbnailData,
        addThumbnailElements,
        thumbnailElements,
        activeId,
        setActiveId,
        activeColor,
        setActiveColor,
        lateralThumbnailIndex,
        setLateralThumbnailIndex,
        activeMPRThumbnailIndex,
        setActiveMPRThumbnailIndex,
        activeModality,
        setActiveModality,
        setStackScrollActiveThumbnailIndex,
        stackScrollActiveThumbnailIndex,
        activeStudyId,
        setActiveStudyId,
        checkIfParentStudyThumbnailIsLoaded,
        impressionHoveredStudyId,
        setImpressionHoveredStudyId,
        seriesHovered,
        setSeriesHovered,
        impressionHovered,
        setImpressionHovered,
        thumbnailLoadingComplete,
        setThumbnailLoadingComplete,
        loadUptoIndex,
        setLoadUptoIndex,
        checkForThumbnailReinference,
        startPrefetching,
        thumbnailLoadMap, setThumbnailLoadMap
      }}
    >
      {props.children}
    </ThumbnailContext.Provider>
  );
};

export default ThumbnailState;
